import { useEffect, useState } from 'react';
import {
  getCurrentIdentity,
  IDENTITY_CHANGED_EVENT,
  refreshCurrentIdentity,
  type SubscriberIdentity,
} from './identity';

/**
 * Reads the current subscriber identity and re-renders on identity changes
 * (same-tab via `identity-changed` custom event, cross-tab via `storage`).
 */
export function useIdentity(): SubscriberIdentity | null {
  const [identity, setIdentity] = useState<SubscriberIdentity | null>(() => getCurrentIdentity());
  useEffect(() => {
    const sync = () => setIdentity(getCurrentIdentity());
    const refresh = () => {
      refreshCurrentIdentity().then(setIdentity);
    };
    refreshCurrentIdentity().then(setIdentity);
    window.addEventListener(IDENTITY_CHANGED_EVENT, sync);
    window.addEventListener('storage', sync);
    window.addEventListener('focus', refresh);
    return () => {
      window.removeEventListener(IDENTITY_CHANGED_EVENT, sync);
      window.removeEventListener('storage', sync);
      window.removeEventListener('focus', refresh);
    };
  }, []);
  return identity;
}
